import React from 'react';
import { useFeatureSurface } from '../../../FeatureSurfaceContext';
import type { FeatureSurfaceName } from '../../../FeatureSurfaceContext';
import styles from './templates-table.module.css';

/** Reputation has no blank-template creation, so it points at the only way to get one. */
const MESSAGE_BY_FEATURE = {
  engage: 'No templates found. Create your first template to get started.',
  reputation: 'No review request automations yet. Add the default automations to get started.',
} satisfies Record<FeatureSurfaceName, string>;

export const TemplatesTableEmpty: React.FC = () => {
  const { feature } = useFeatureSurface();

  return <p className={styles.templatesTableEmpty}>{MESSAGE_BY_FEATURE[feature]}</p>;
};
